import {COLORS} from '../../../../../../users/data';
import {
  MANAGEMENT_PERMISSION_IDS,
  WORKER_PERMISSION_IDS,
} from '../../../data/permissionsList';
import {
  createDefaultRole,
  DepartmentFormValues,
  RoleFormValues,
} from '../../../types';

type RolePreset = Partial<Omit<RoleFormValues, 'id' | 'departmentId'>>;

const buildRole = (
  departmentId: string,
  preset: RolePreset,
): RoleFormValues => ({
  ...createDefaultRole(departmentId),
  ...preset,
});

const manualRolePresets: RolePreset[] = [
  {
    roleType: '',
    icon: 'icon1',
    permissionLevel: 'management',
    customPermission: true,
    permissions: MANAGEMENT_PERMISSION_IDS,
    color: COLORS[0].color,
  },
  {
    roleType: '',
    icon: 'icon2',
    permissionLevel: 'work',
    customPermission: true,
    permissions: WORKER_PERMISSION_IDS,
    color: COLORS[0].color,
  },
];

const templateRolePresets: Record<string, RolePreset[]> = {
  הנהלה: [
    {
      roleType: 'בעלים',
      icon: 'icon9',
      permissionLevel: 'senior_management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[11].color,
    },
    {
      roleType: 'אדמין',
      icon: 'icon3',
      permissionLevel: 'senior_management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[11].color,
    },
  ],
  מטבח: [
    {
      roleType: 'מטבח ניהול',
      icon: 'icon20',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[4].color,
    },
    {
      roleType: 'סו שף',
      icon: 'icon5',
      permissionLevel: 'management',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[4].color,
    },
    {
      roleType: 'טבח',
      icon: 'icon5',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[4].color,
    },
    {
      roleType: 'שוטף כלים',
      icon: 'icon22',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[4].color,
    },
  ],
  מסעדה: [
    {
      roleType: 'מנהל רשת',
      icon: 'icon3',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[1].color,
    },
    {
      roleType: 'אירוח',
      icon: 'icon2',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[1].color,
    },
    {
      roleType: 'מלצר',
      icon: 'icon13',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[1].color,
    },
    {
      roleType: 'כללי',
      icon: 'icon19',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[1].color,
    },
  ],
  בר: [
    {
      roleType: 'בר ניהול',
      icon: 'icon23',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[3].color,
    },
    {
      roleType: 'ברמן/נית',
      icon: 'icon10',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[3].color,
    },
  ],
  אדמיניסטרציה: [
    {
      roleType: 'ראיית חשבון',
      icon: 'icon8',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[10].color,
    },
    {
      roleType: 'משפטי',
      icon: 'icon24',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[10].color,
    },
  ],
  מאפיה: [
    {
      roleType: 'ניהול מאפיה',
      icon: 'icon25',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[5].color,
    },
    {
      roleType: 'אופה',
      icon: 'icon12',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[5].color,
    },
  ],
  קונדיטוריה: [
    {
      roleType: 'ניהול קונדיטוריה',
      icon: 'icon26',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[9].color,
    },
    {
      roleType: 'קונדיטוריה',
      icon: 'icon18',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[9].color,
    },
  ],
  כספים: [
    {
      roleType: 'מטבח ניהול',
      icon: 'icon20',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[4].color,
    },
    {
      roleType: 'סו שף',
      icon: 'icon5',
      permissionLevel: 'management',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[4].color,
    },
    {
      roleType: 'טבח',
      icon: 'icon5',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[4].color,
    },
    {
      roleType: 'שוטף כלים',
      icon: 'icon22',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[4].color,
    },
  ],
  משפטית: [
    {
      roleType: 'מנהל רשת',
      icon: 'icon3',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[1].color,
    },
    {
      roleType: 'אירוח',
      icon: 'icon2',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[1].color,
    },
    {
      roleType: 'מלצר',
      icon: 'icon13',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[1].color,
    },
    {
      roleType: 'כללי',
      icon: 'icon19',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[1].color,
    },
  ],
  לוגיסטיקה: [
    {
      roleType: 'בר ניהול',
      icon: 'icon23',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[3].color,
    },
    {
      roleType: 'ברמן/נית',
      icon: 'icon10',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[3].color,
    },
  ],
  'משאבי אנוש': [
    {
      roleType: 'ראיית חשבון',
      icon: 'icon8',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[10].color,
    },
    {
      roleType: 'משפטי',
      icon: 'icon24',
      permissionLevel: 'work',
      customPermission: true,
      permissions: WORKER_PERMISSION_IDS,
      color: COLORS[10].color,
    },
  ],
  תחבורה: [
    {
      roleType: 'ניהול מאפיה',
      icon: 'icon25',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[5].color,
    },
    {
      roleType: 'אופה',
      icon: 'icon12',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[5].color,
    },
  ],
  ביטחון: [
    {
      roleType: 'ניהול קונדיטוריה',
      icon: 'icon26',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[9].color,
    },
    {
      roleType: 'קונדיטוריה',
      icon: 'icon18',
      permissionLevel: 'management',
      customPermission: true,
      permissions: MANAGEMENT_PERMISSION_IDS,
      color: COLORS[9].color,
    },
  ],
};

export const getManualRoles = (departments: DepartmentFormValues[]) =>
  departments.flatMap(department => {
    const matchingTemplatePresets = templateRolePresets[department.name]
      ?.slice(0, 2)
      ?.map(preset => ({
        ...preset,
        roleType: '',
      }));
    const presets = matchingTemplatePresets ?? manualRolePresets;

    return presets.map(preset => buildRole(department.id, preset));
  });

export const getTemplateRoles = (
  departments: DepartmentFormValues[],
  roleTypes?: Array<{
    _id: string;
    name?: {he?: string};
    icon?: string;
  }>,
) =>
  departments.flatMap(department => {
    const presets = templateRolePresets[department.name] ?? [];

    return presets.map(preset => {
      const existingRoleType = roleTypes?.find(
        roleType => roleType.name?.he === preset.roleType,
      );

      return buildRole(department.id, {
        ...preset,
        roleType: existingRoleType?._id ?? preset.roleType,
      });
    });
  });
